"use client";

import React from "react";
import { Scissors } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const categories = [{
  id: "hair",
  title: "Haar"
}, {
  id: "beard",
  title: "Baard"
}, {
  id: "children",
  title: "kinderen T/M 13 jaar"
}];
const services = [{
  categoryId: "hair",
  name: "Knippen en styleren",
  price: "€ 27,50",
  duration: "30 min",
  description: "Professioneel knippen en in model brengen voor een perfect resultaat."
}, {
  categoryId: "hair",
  name: "Knippen, styleren en baard bijwerken",
  price: "€ 45,00",
  duration: "60 min",
  description: "De ultieme verzorging voor zowel uw kapsel als uw baard."
}, {
  categoryId: "children",
  name: "Jongens knippen",
  price: "€ 22,50",
  duration: "25 min",
  description: "Een stoer kapsel voor de jonge heren tot en met 13 jaar."
}, {
  categoryId: "beard",
  name: "Baard scheren de lux",
  price: "€ 22,50",
  duration: "30 min",
  description: "Traditionele scheerbeurt met warme handdoeken en premium producten."
}, {
  categoryId: "beard",
  name: "Baard trimmen en lijnen",
  price: "€ 20,00",
  duration: "20 min",
  description: "Uw baard weer perfect in vorm en tot in de puntjes verzorgd."
}, {
  categoryId: "beard",
  name: "Contour en lijnwerk",
  price: "€ 10,00",
  duration: "15 min",
  description: "Scherpe contouren en strakke lijnen voor een verzorgde look."
}, {
  categoryId: "beard",
  name: "alleen zijkanten opscheren",
  price: "€ 20,00",
  duration: "20 min",
  description: "Snel en strak de zijkanten laten bijwerken."
}, {
  categoryId: "hair",
  name: "Een stande tendeuze",
  price: "€ 17",
  duration: "20 min",
  description: "Snel en vakkundig de contouren en lengte bijwerken met de tondeuse."
}];
export default function PriceList() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  return <section id="de-prijslijst" className="dark bg-background text-foreground py-24 px-4 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-primary/5 blur-[120px] pointer-events-none rounded-lg" />

      <div className="max-w-4xl mx-auto relative z-10">
        <div ref={headerRef} className={`text-center mb-16 transition-all duration-1000 ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h2 className="text-4xl md:text-5xl font-bold font-serif mb-6 text-foreground">
            Onze <span className="text-primary">Tarieven</span>
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
            Een transparant overzicht van al onze behandelingen en prijzen voor heren en jongens. Ervaar premium kwaliteit en vakmanschap.
          </p>
        </div>

        <div className="space-y-16 mb-24">
          {categories.map((category, catIndex) => {
          const categoryServices = services.filter(s => s.categoryId === category.id);
          return <div key={category.id} data-index={catIndex} className="animate-in fade-in slide-in-from-bottom-8 duration-1000 fill-mode-both" style={{
            animationDelay: `${catIndex * 200}ms`
          }}>
                <h3 className="text-2xl font-bold text-primary mb-8 uppercase tracking-widest border-b border-primary/20 pb-3 flex items-center gap-3">
                  <Scissors className="w-6 h-6 text-primary/80" />
                  {category.title}
                </h3>
                
                <div className="space-y-6">
                  {categoryServices.map((service, srvIndex) => <div key={service.name} data-index={srvIndex} className="group">
                      <div className="flex items-end justify-between">
                        <div className="flex flex-col">
                          <span className="text-lg md:text-xl font-bold text-foreground group-hover:text-primary transition-colors duration-300">
                            {service.name}
                          </span>
                        </div>
                        <div className="flex-grow border-b-2 border-dotted border-muted-foreground/30 mx-4 mb-2 group-hover:border-primary/50 transition-colors duration-300" />
                        <span className="text-xl md:text-2xl font-bold text-primary whitespace-nowrap">
                          {service.price}
                        </span>
                      </div>
                      <p className="text-muted-foreground text-sm md:text-base mt-1 max-w-2xl">
                        {service.description}
                      </p>
                    </div>)}
                </div>
              </div>;
        })}
        </div>

        <div className="sticky bottom-8 flex justify-center z-20 pointer-events-none">
          <div className="bg-background/80 backdrop-blur-md p-2 rounded-lg shadow-2xl border border-primary/20 pointer-events-auto">
            {}
            <Button asChild size="lg" className="rounded-lg px-8 py-6 text-lg font-bold shadow-primary/20 hover:shadow-primary/40 hover:shadow-[0_0_30px_0px_var(--tw-shadow-color)] transition-all duration-300">
              <Link to="https://salonkee.nl/salon/he-kappers" newTab>
                Maak een afspraak
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}